import PropTypes from 'prop-types';

export default function OutlineTransactions(props) {
    const { color = 'currentColor', size = 20, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m3.514 12.599 7.807-7.806V7.93c-.024.652.842 1 1.28.53a.747.747 0 0 0 .219-.53V2.983a.79.79 0 0 0-.463-.692 1.553 1.553 0 0 0-.287-.057H7.123c-.983.016-.987 1.482 0 1.499h3.138l-7.807 7.806c-.68.702.347 1.748 1.06 1.06ZM16.487 7.4l-7.806 7.806V12.07c-.015-.983-1.483-.987-1.5 0v4.947c.012.306.204.6.498.701.081.027.168.038.252.048h4.947c.984-.016.987-1.482 0-1.499H9.741l7.806-7.806c.681-.702-.347-1.748-1.06-1.06Z"
                fill={color}
            />
        </svg>
    );
}

OutlineTransactions.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
